import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'pc-key-metrics',
  standalone: true,
  imports: [],
  templateUrl: './key-metrics.component.html',
  styleUrl: './key-metrics.component.scss'
})
export class KeyMetricsComponent implements OnInit {
  @Input() projectSize: string = '';
  @Input() servicesList: Array<string> = [];
  @Input() clientName: string = '';
  @Input() locationName: string = '';
  @Input() sector: string = '';
  @Input() architectName: string = '';
  @Input() contractorName: string = '';

  ngOnInit(): void {

  }
}
